var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 ma-0 container",attrs:{"fluid":""}},[_c('AsideConfig')],1)}
var staticRenderFns = []

export { render, staticRenderFns }